export const NotFoundScene = () => {
  return (
    <div>
      <h1>Not found</h1>
    </div>
  );
};
